import ModalComponent from './component'
import { commonRenderProps } from '../common/props'

export default (
  context,
  url?: string,
  moduleId?: number,
  onModuleAction?: any,
  onModuleLoading?: any,
) => {
  url = url || `${import.meta.env.VITE_VUE_URL}/#/module/${moduleId}`

  const currentModal = ModalComponent({
    ...commonRenderProps({ context }),

    url,

    handleCloseModal: async (frame, uid) => {
      if (frame && uid) {
        frame.contentWindow.postMessage(
          {
            name: 'onClose',
            uid,
          },
          url,
        )
      }
      setTimeout(() => {
        currentModal.close()
      }, 100)
    },

    onModuleAction: (moduleContext) => {
      if (typeof onModuleAction === 'function') {
        onModuleAction(moduleContext)
      }
    },

    onModuleLoading: (module, loading) => {
      if (typeof onModuleLoading === 'function') {
        onModuleLoading(module, loading)
      }
    },
  })

  currentModal.render('body')

  return currentModal
}
